import useSWR from 'swr';

import { FamilyPlanSubscription } from '@/components/app/manageSubscription/ManageSubscriptionLayout/components/FamilyPlanBlock/types';

import { useApi } from '../api';

export function useManageSubscription() {
	const apiRequest = useApi();

	const { data, isLoading, error, mutate } = useSWR<FamilyPlanSubscription>(
		'/manage-subscription',
		async endpoint => {
			const response = await apiRequest<FamilyPlanSubscription>({
				endpoint,
				method: 'GET',
			});
			return response.data;
		},
	);

	// The only way to know if the user is on a family plan is to check if there are family members returned from /manage-subscription
	const hasFamilyPlanMembers = data?.family_members?.members.length;

	return {
		data,
		hasFamilyPlan: Boolean(hasFamilyPlanMembers),
		error,
		loading: isLoading,
		mutate,
	};
}
